export const FORWARD = 'FORWARD'
export const NOTE = 'NOTE'
export const REPLY = 'REPLY' // used for invalidating all types of replies.
export const REPLY_ALL = 'REPLY_ALL'
export const REPLY_DIRECT = 'REPLY_DIRECT'
